import store from '../store'

const interceptor = {
	
	hasModuleAccess (name, type = "read") {
      
		let access = false,
			loggedInUser = store.getters.loggedInUser,
			modules = store.getters.getModules

		let module = name && modules[name] ? modules[name] : null

		if (!module) return false

		if (loggedInUser && loggedInUser.modules) {

			let module_access = loggedInUser.modules.filter( item => module.id == item.module_id )

			if (module_access.length > 0) {
			  
				module_access = module_access[0]

				switch (type) {
					case "create":
						access = !!Number(module_access.is_create_allowed)
						break
					case "update":
						access = !!Number(module_access.is_update_allowed)
						break
					case "read":
						access = !!Number(module_access.is_read_allowed)
						break
					case "delete":
						access = !!Number(module_access.is_delete_allowed)
						break
				}

			}
		}

      	return access
    }
}

export default interceptor
